export const locale = {
    lang: 'pt',
    data: {
      'EDITOR': {
        'CARGANDO': 'Carregando informação',
        'GUARDANDO': 'Salvando alterações',
        'ELEMENTOS': {
          'GUIA': 'Elementos deste bloco',
          'COLORES': {
            'ORIGINAL': 'Elemento não modificado',
            'MODIFICADO': 'Item modificado'
          },
          'TOOLTIPS': {
            'ORIGINAL': 'Nenhum elemento foi modificado',
            'MODIFICADO': 'Um ou mais itens foram modificados',
            'COMPLETO': 'Todos os elementos foram modificados',
            'AMPLIAR': 'Ver em tamanho grande',
            'ELIMINAR': 'Exclua esta imagem',
            'IMPORTAR': 'Importar este item de outro idioma',
            'CONFIGDOMINIO': 'Configuração de domínio de back-end',
            'COPIARURL': 'Link de cópia'
          },
          'ETIQUETAS': {
            'INTERFAZ': {
              'TITULO': 'Configuração por corretor',
              'SUBTITULO': 'Você pode ver e modificar as configurações de cada corretor disponível',
              'PASOINICIAL': 'Selecione um corretor da lista para mostrar sua configuração',
              'SELBROKER': 'Corretor selecionado',
              'SELOPC': 'Opção selecionada',
              'SINJSONS': 'Falha ao carregar informações deste corretor, tente mais tarde',
              'DOMINIO': {
                'TITULO': 'Configuração de domínio de back-end do corretor',
                'ACTIVAR': 'Ative o domínio associado ao corretor',
                'DOMINIO': 'Domínio associado ao corretor'
              },
              'MODAL': {
                'TITULO': 'Elemento de importação',
                'SUBTITULO': 'Selecione o idioma do qual deseja importar este item'
              }
            },
            'IMAGEN': {
              'NOHAY': 'Não tem imagem',
              'ACTUAL': 'Imagem atual'
            },
            'TEXTO': {
              'INGRESAR': 'Digite seu texto'
            },
            'VIDEO': {
              'NOVIDEO': 'Você não enviou um vídeo',
              'GUARDANDO': 'Salvando o vídeo, não saia desta tela até que o upload seja concluído'
            }
          },
          'BOTONES': {
            'ENTRAR': 'Editar características da pesquisa',
            'REGRESAR': 'Volte',
            'CONTINUAR': 'Prosseguir',
            'CANCELAR': 'Cancelar',
            'GUARDAR': 'Salvar alterações',
            'IMAGEN': 'Mudar a imagem',
            'EDITOR': 'Editar mensagem',
            'ELEMENTOS': 'Ajuda',
            'ACTIVAR': 'mostrar',
            'DESACTIVAR': 'Esconder',
            'VERVIDEO': 'Ver vídeo',
            'CARGARVIDEO': 'Carregar arquivo de vídeo',
            'OTROVIDEO': 'Envie outro arquivo de vídeo',
            'SI': 'sim',
            'NO': 'Não',
            'INFO': 'Importante',
            'ADDIMG': 'Adicionar imagem'
          },
          'MODALIMAGEN': {
            'TITULO': 'Adicionar imagem à mensagem',
            'TABS': {
              'INSTRUCCIONES': {
                'TITULO': 'Instruções',
                'PASO_1': 'Clique na guia \'Imagens\', onde você pode escolher uma imagem já carregada, ou você também pode fazer upload de uma nova imagem',
                'PASO_2': 'Se quiser escolher uma imagem já carregada, posicionando o cursor sobre a imagem desejada, você pode realizar duas ações: Visualizar a imagem ou copiar o link',
                'PASO_2_1': 'Para visualizar, clique no botão correspondente ao botão da imagem com o seguinte ícone',
                'PASO_2_2': 'Para copiar o link, clique no botão ao botão na imagem com o seguinte ícone',
                'PASO_3': 'Se você deseja fazer upload de uma nova imagem, clique no botão com o seguinte ícone',
                'PASO_4': 'Quando terminar de enviar a imagem, você receberá automaticamente o link',
                'PASO_5': 'Volte para o editor de mensagens e clique no botão para inserir uma imagem, com o seguinte ícone',
                'PASO_6': 'Na janela pop-up, coloque o link copiado e defina o tamanho da imagem, expresso em pixels. Quando terminar, clique no botão Salvar. A janela pop-up irá fechar e a imagem será colocada no editor com o tamanho definido'
              },
              'IMAGENES': {
                'TITULO': 'Imagens',
                'CARGANDO': 'Carregando imagens disponíveis',
                'NOTA': '* As imagens mostradas aqui são salvas no gerenciador de arquivos',
                'TITULO_2': 'Imagens disponíveis',
                'ADD': 'Adicionar uma nova imagem',
                'NOIMG': 'Sem imagens disponíveis',
                'URLCOPIADA': 'Link da imagem copiado para a área de transferência',
                'OKBOT': 'OK'
              },
            }
          }
        },
        'CATALOGOS': {
          'temas': {
            'temaFocusArea2': 'Conjunto de cores 1',
            'theme-temaIzzi': 'Conjunto de cores 2',
            'theme-blue-gray-dark': 'Conjunto de cores 3',
            'theme-pink-dark': 'Conjunto de cores 4',
            'theme-temaIzzi-2': 'Conjunto de cores 5',
            'theme-temaItbm': 'Conjunto de cores 6',
          },
          'numColumnas': {
            '1': '1 colunas',
            '4': '4 colunas',
            '5': '5 colunas',
          },
          'segundos': {
            '1000': '1 segundo',
            '2000': '2 segundos',
            '3000': '3 segundos',
            '4000': '4 segundos',
            '5000': '5 segundos',
            '6000': '6 segundos',
            '7000': '7 segundos',
            '8000': '8 segundos',
            '9000': '9 segundos',
            '10000': '10 segundos',
            '11000': '11 segundos',
            '12000': '12 segundos',
            '13000': '13 segundos',
            '14000': '14 segundos',
            '15000': '15 segundos',
            '16000': '16 segundos',
            '17000': '17 segundos',
            '18000': '18 segundos',
            '19000': '19 segundos',
            '20000': '20 segundos',
          },
          'logosIniciales': {
            '0': 'Logotipo da CulturalGO'
          }
        },
        'ADVERTENCIAS': {
          'URLEXTERNA': 'Aviso: Se o site de origem não permitir o acesso à página de sites externos, o conteúdo não será exibido',
          'TEMPLATEFALTANTE': 'Aviso: este modelo não está disponível para este idioma',
          'CONFIGURACION': {
            'ACTIVAR': 'Cuidado: Ao ativar a configuração personalizada, todos os itens especificados nesta tela serão colocados na interface da plataforma, certifique-se de ter colocado todos os itens corretos \n\n Deseja continuar e ativar a configuração personalizada?',
            'DESACTIVAR': 'Atenção: Ao desativar a configuração customizada, serão colocados os elementos padrão estabelecidos na plataforma para esta corretora e para todos os usuários pertencentes a ela. \n\n Deseja continuar e desativar a configuração personalizada? '
          },
          'PRIORIDAD': {
            '1': 'Se este elemento estiver ativo, a prioridade será dada sobre as imagens de fundo',
            '2': 'Se este elemento estiver ativo, a prioridade será dada às imagens de fundo e ao fundo do vídeo.'
          }
        },
        'PANTALLAS': {
          'LOGIN': {
            'TITULO': 'Conecte-se',
            'PASOS': {
              'VARIOS': {
                'TITULO': 'Itens variados',
                'ELEMENTOS': {
                  'images_broker': 'Logotipo da corretora',
                  'title': 'Título principal',
                  'images_login': 'Logotipo do sistema',
                  'images_logout': 'Imagem exibida ao sair',
                  'changeTime': 'Intervalo de tempo entre as imagens'
                }
              },
              'BACKGROUNDS': {
                'TITULO': 'Imagens de fundo',
                'ELEMENTOS': {
                  'agregar': 'Adicionar uma imagem',
                  'importar': 'Importar imagens de outras configurações',
                }
              },
              'VIDEO': {
                'TITULO': 'Vídeo de fundo',
                'ELEMENTOS': {
                  'enable': 'Habilitar vídeo de fundo',
                  'video': 'Vídeo para mostrar',
                  'loop': 'Ativar repetição automática',
                  'mute': 'Mostrar vídeo sem som'
                }
              },
              'EXTERNO': {
                'TITULO': 'Conteúdo externo',
                'ELEMENTOS': {
                  'enable': 'Habilitar conteúdo externo',
                  'url': 'Link de conteúdo externo para exibir',
                }
              }
            }
          },
          'HOME': {
            'TITULO': 'Pagina inicial',
            'PASOS': {
              'BRAND':{
                'TITULO': 'Identidade do sistema no menu lateral',
                'ELEMENTOS': {
                  'logo': 'Logotipo do sistema',
                  'name': 'Nome do sistema'
                }
              },
              'LOGOINICIAL': {
                'TITULO': 'Logotipo inicial',
                'ELEMENTOS': {
                  'show': 'Mostrar logotipo inicial do sistema',
                  'time': 'Tempo de exibição do logotipo (expresso em segundos)',
                  'type': 'Tipo de logotipo inicial para exibir'
                }
              },
              'MOSAICO': {
                'TITULO': 'Mosaico de imagens',
                'ELEMENTOS': {
                  'branding_show': 'Exibir logotipo da marca do sistema',
                  'branding_image': 'Logotipo da marca do sistema',
                  'grayFilter': 'Filtro cinza em imagens de inicialização',
                  'bgGridColumns': 'Número de colunas de imagens a serem exibidas'
                }
              },
              'TEMAS': {
                'TITULO': 'Tema de cores da plataforma',
                'ELEMENTOS': {
                  'theme': 'Tema de cores para exibir no sistema'
                }
              },
              'BACKGROUNDS': {
                'TITULO': 'Imagens de fundo',
                'ELEMENTOS': {
                  'agregar': 'Adicionar uma imagem',
                  'importar': 'Importar imagens de outras configurações',
                }
              },
              'VIDEO': {
                'TITULO': 'Vídeo de fundo',
                'ELEMENTOS': {
                  'enable': 'Habilitar vídeo de fundo',
                  'video': 'Vídeo para mostrar',
                  'loop': 'Ativar repetição automática',
                  'mute': 'Mostrar vídeo sem som'
                }
              },
              'EXTERNO': {
                'TITULO': 'Conteúdo externo',
                'ELEMENTOS': {
                  'enable': 'Habilitar conteúdo externo',
                  'url': 'Link de conteúdo externo para exibir',
                }
              },
              'LOADER': {
                'TITULO': 'Carregamento de imagens .gif',
                'ELEMENTOS': {
                  'image': 'Image loading .gif',
                  'GUARDANDO': 'Salvando imagem, não sair desta tela até que o carregamento esteja completo'
                }
              },
            }
          },
          'TEMPLATES': {
            'TITULO': 'Modelos de email',
            'PASOS': {
              'RT_1': {
                'TITULO': 'Requisitos técnicos, enviados ao registrar um novo produto',
                'ELEMENTOS': {
                  'asunto': 'Assunto da mensagem',
                  'mensaje': 'Corpo da mensagem'
                }
              },
              'RT_2': {
                'TITULO': 'Requisitos técnicos, mensagem de demonstração enviada durante a validação',
                'ELEMENTOS': {
                  'asunto': 'Assunto da mensagem',
                  'mensaje': 'Corpo da mensagem'
                }
              },
              'PASS_3': {
                'TITULO': 'Correio enviado ao atualizar a senha do usuário',
                'ELEMENTOS': {
                  'asunto': 'Assunto da mensagem',
                  'mensaje': 'Corpo da mensagem'
                }
              },
              'PASS_4': {
                'TITULO': 'Email enviado ao atualizar o perfil do usuário',
                'ELEMENTOS': {
                  'asunto': 'Assunto da mensagem',
                  'mensaje': 'Corpo da mensagem'
                }
              },
              'GETMYCODE_6': {
                'TITULO': 'Correio enviado com GetMyCode',
                'ELEMENTOS': {
                  'asunto': 'Assunto da mensagem',
                  'mensaje': 'Corpo da mensagem'
                }
              },
              'RT_7': {
                'TITULO': 'Correio para aceitação de requisitos técnicos',
                'ELEMENTOS': {
                  'asunto': 'Assunto da mensagem',
                  'mensaje': 'Corpo da mensagem'
                }
              },
            }
          }
        }
      }
    }
};
